<!-- modal.component.html -->
<div class="modal-container">
  <img class="logimg" src="/assets/images/welcome-triidy.jpg" alt="Login Image">
  <button mat-button class="overlay-button" (click)="navigateToVersion2()">¡Probar ahora!</button>
</div>
